import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgSunscreenGlyphSecondary from './svgs/SunscreenGlyphSecondary.js';
import SvgSunscreenGlyph from './svgs/SunscreenGlyph.js';
import { useIcon } from '../../shared-components/icon/index.js';

var sunscreenGlyph = (props => useIcon(SvgSunscreenGlyph, SvgSunscreenGlyphSecondary, props));

export { sunscreenGlyph as default };
